/* Artisticases — review text repair.

   Judge.me hands back some review bodies as mojibake: text that was UTF-8,
   decoded as Windows-1252 somewhere upstream, so "😊" arrives as "ðŸ˜Š".
   That is reversible — map each character back to the cp1252 byte it stands
   for and decode the result as UTF-8 — so emoji are recovered rather than
   thrown away. Only when the bytes refuse to decode do we strip, and then
   only runs that look like mojibake residue, leaving ordinary accented text
   ("café", "señor") alone.

   Exposed as window.acReviewText(text). */
(function () {
  /* The 0x80-0x9F range is where cp1252 differs from Latin-1. */
  var CP1252 = {
    0x20AC: 0x80, 0x201A: 0x82, 0x0192: 0x83, 0x201E: 0x84, 0x2026: 0x85,
    0x2020: 0x86, 0x2021: 0x87, 0x02C6: 0x88, 0x2030: 0x89, 0x0160: 0x8A,
    0x2039: 0x8B, 0x0152: 0x8C, 0x017D: 0x8E, 0x2018: 0x91, 0x2019: 0x92,
    0x201C: 0x93, 0x201D: 0x94, 0x2022: 0x95, 0x2013: 0x96, 0x2014: 0x97,
    0x02DC: 0x98, 0x2122: 0x99, 0x0161: 0x9A, 0x203A: 0x9B, 0x0153: 0x9C,
    0x017E: 0x9E, 0x0178: 0x9F
  };

  /* A character that could be one byte of a UTF-8 sequence read as cp1252. */
  function asByte(code) {
    if (code <= 0xFF) return code;
    return Object.prototype.hasOwnProperty.call(CP1252, code) ? CP1252[code] : -1;
  }

  function repair(text) {
    if (!/[Â-ô]/.test(text)) return text;      /* no lead byte, nothing to fix */
    var bytes = [];
    for (var i = 0; i < text.length; i++) {
      var b = asByte(text.charCodeAt(i));
      if (b < 0) return text;                             /* not mojibake after all */
      bytes.push(b);
    }
    try {
      var decoded = new TextDecoder('utf-8', { fatal: true }).decode(new Uint8Array(bytes));
      /* a successful decode that still holds replacement chars is not a win */
      return decoded.indexOf('�') === -1 ? decoded : text;
    } catch (e) {
      return text;
    }
  }

  /* Last resort: drop replacement characters and runs of two or more
     mojibake-alphabet characters, which ordinary prose does not produce. */
  function strip(text) {
    return text
      .replace(/�/g, '')
      .replace(/[Â-ô][-¿ŒœŠšŸŽžƒˆ˜–—‘-„†-•…‰‹›€™]{1,3}/g, '')
      .replace(/\s{2,}/g, ' ')
      .trim();
  }

  window.acReviewText = function (text) {
    var value = (text || '').replace(/\s+/g, ' ').trim();
    if (!value) return '';
    var repaired = repair(value);
    return repaired === value ? strip(value) : repaired;
  };
})();
